import {NAME as API_ERROR_NAME} from '@errors/ApiError';
import type ApiError from '@errors/ApiError';
import {NAME as PAYMENT_ERROR_NAME} from '@errors/PaymentError';
import type PaymentError from '@errors/PaymentError';

export function isError(error: unknown): error is Error {
    return error instanceof Error && typeof error.stack !== 'undefined';
}

export function isPaymentError(error: unknown): error is PaymentError {
    return error instanceof Error && error.name === PAYMENT_ERROR_NAME;
}

export function isApiError(error: unknown): error is ApiError {
    return error instanceof Error && error.name === API_ERROR_NAME;
}
